module.exports = __webpack_public_path__ + "static/media/DSC_0475.601bf844.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0475.jpg
// module id = 699
// module chunks = 0